export default function (second) {
    const hours = Math.floor(second / 3600)
    const minutes = Math.floor(second / 60) % 60
    const seconds = second % 60

    return [hours, minutes, seconds]
        .map(v => v < 10 ? "0" + v : v)
        .filter((v, i) => v !== "00" || i > 0)
        .join(":")
}
